<!-- 選擇門市群組 -->
<ng-template #Modal let-data let-ref="dialogRef"  >
    <nb-card class="staffInfoTemplate mo1"  [nbSpinner]="info.IsLoding">
      <nb-card-header>
        選擇複製出單機
      </nb-card-header>
      <nb-card-body>

        <div class="d-flex mx-0 mt-2 justify-content-between">         
          <nb-select class="col-auto pr-0 ml-auto"   style="width:180px" 
              [(ngModel)]="selectORG_Store_ID" (selectedChange)="onQuery()">
              <nb-option *ngFor="let e of storeSelectList" [value]="e.value" > {{ e.content }}</nb-option>
          </nb-select>         
        </div>



        <div class="mt-3"> 
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>出單機名稱</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let e of mainDataList ">
                <tr>
                  <td> {{ e.PrintMachine_Name }}</td>
                  <td>
                    <nb-toggle status="info" [(checked)]="e.IsOK_Group" 
                      (checkedChange)="onSelectG(e)">
                    </nb-toggle>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSavePdG();">確定</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>


    